const slugify = (title) =>
  title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');

const rawResources = [
  {
    title: "Home Buying Guide",
    description:
      "Buying your first home is one of life's biggest milestones. While the process may seem overwhelming at first, understanding each step can help you make informed decisions and avoid costly mistakes. This guide walks you through everything you need to know—from setting your budget to receiving the keys to your new home.",
   
    steps: [
      {
        heading: 'Why Buy Your First Home?',
        intro: 'Owning a home is more than just having a place to live. It offers financial stability, personal freedom, and the opportunity to build long-term wealth.',
        subheading: 'Benefits of Homeownership',
        bullets: [
          'Build equity over time instead of paying rent.',
          'Enjoy greater privacy and security.',
          'Customize your home to match your lifestyle.',
          'Benefit from potential property value appreciation.',
          'Create long-term financial stability for your family',
        ],
        intro2: '',
      },
      {
        heading: 'Step 1: Assess Your Financial Readiness',
        intro: 'Before you begin searching for a home, take a close look at your finances.',
        subheading: 'Consider the following:',
        bullets: [
          'Gather income and employment documents',
          'Compare rates from multiple lenders',
          'Understand fixed vs. adjustable-rate mortgages',
          'Get your pre-approval letter in writing',
        ],
        intro2: 'Having a clear understanding of your financial position will help you determine a comfortable home-buying budget.',
      },
      {
  heading: 'Step 2: Set a Realistic Budget',
  intro:
    'Many first-time buyers focus only on the purchase price, but there are additional costs involved.',
  subheading: 'Include expenses such as:',
  bullets: [
    'Down payment',
    'Loan processing fees',
    'Property registration',
    'Legal documentation',
    'Home inspection',
    'Insurance',
    'Property taxes',
    'Moving expenses',
    'Maintenance costs',
  ],
  intro2:
    'Buying within your budget helps you enjoy homeownership without financial stress.',
},
  {
  heading: 'Step 3: Get Pre-Approved For A Mortgage',
  intro:
    'A mortgage pre-approval gives you an estimate of how much a lender is willing to finance.',
  subheading: 'Advantages include:',
  bullets: [
    'Knowing your price range.',
    'Faster buying process.',
    'Stronger position when making an offer.',
    'Greater confidence while searching.',
  ],
  intro2:
    'Prepare documents such as income proof, bank statements, identity verification, and employment records.',
},
{
  heading: 'Step 4: Choose The Right Location',
  intro:
    "The perfect home isn't just about the property—it's also about the neighborhood.",
  subheading: 'Consider factors like:',
  bullets: [
    'Distance to work',
    'Schools and colleges',
    'Hospitals',
    'Public transportation',
    'Shopping centers',
    'Parks and recreation',
    'Safety and security',
    'Future development plans',
  ],
  intro2:
    "A good location increases both your quality of life and your property's future value.",
},
{
  heading: 'Step 5: Assess Your Financial Readiness',
  intro:
    'Before you begin searching for a home, take a close look at your finances.',
  subheading: 'Consider the following:',
  bullets: [
    'Your monthly income and expenses.',
    'Existing loans or debts.',
    'Savings for a down payment.',
    'Emergency funds.',
    'Credit score and financial history.',
  ],
  intro2:
    'Having a clear understanding of your financial position will help you determine a comfortable home-buying budget.',
},   
{
  heading: 'Step 6: Set A Realistic Budget',
  intro:
    'Many first-time buyers focus only on the purchase price, but there are additional costs involved.',
  subheading: 'Include expenses such as:',
  bullets: [
    'Down payment',
    'Loan processing fees',
    'Property registration',
    'Legal documentation',
    'Home inspection',
    'Insurance',
    'Property taxes',
    'Moving expenses',
    'Maintenance costs',
  ],
  intro2:
    'Buying within your budget helps you enjoy homeownership without financial stress.',
},
{
  heading: 'Step 7: Get Pre-Approved For A Mortgage',
  intro:
    'A mortgage pre-approval gives you an estimate of how much a lender is willing to finance.',
  subheading: 'Advantages include:',
  bullets: [
    'Knowing your price range.',
    'Faster buying process.',
    'Stronger position when making an offer.',
    'Greater confidence while searching.',
  ],
  intro2:
    'Prepare documents such as income proof, bank statements, identity verification, and employment records.',
},{
  heading: 'Step 8: Choose The Right Location',
  intro:
    "The perfect home isn't just about the property—it's also about the neighborhood.",
  subheading: 'Consider factors like:',
  bullets: [
    'Distance to work',
    'Schools and colleges',
    'Hospitals',
    'Public transportation',
    'Shopping centers',
    'Parks and recreation',
    'Safety and security',
    'Future development plans',
  ],
  intro2:
    "A good location increases both your quality of life and your property's future value.",
},{
  heading: 'Common Mistakes To Avoid',
  intro:
    'Many first-time buyers make avoidable errors during the purchasing process.',
  subheading: 'Avoid these common mistakes:',
  bullets: [
    'Buying beyond your budget.',
    'Skipping mortgage pre-approval.',
    'Ignoring additional ownership costs.',
    'Not comparing multiple properties.',
    'Skipping a professional inspection.',
    'Making emotional decisions.',
    'Overlooking neighbourhood research.',
    'Failing to review legal documents thoroughly.',
  ],
  intro2:'',
} ,
{
  heading: 'First-Time Home Buyer Checklist',
  intro:
    "Before purchasing your home, make sure you've completed these essential steps:",
    subheading: '',
  checklist: [
    'Review your finances',
    'Set a realistic budget',
    'Save for a down payment',
    'Get mortgage pre-approval',
    'Research neighbourhoods',
    'Compare multiple properties',
    'Schedule a home inspection',
    'Verify legal documents',
    'Understand closing costs',
    'Secure homeowners insurance',
  ],
   intro2:'',
},
    ],
    finalThoughts: [
      {
         title: "Final Thoughts",
    description:
      "Buying your first home is an exciting journey and one of the most rewarding investments you'll ever make. By planning carefully, understanding each step, and seeking professional guidance when needed, you can make confident decisions and find a home that fits both your lifestyle and your budget.",
      description2:
      "Whether you're just beginning your search or preparing to make an offer, taking the time to educate yourself today will help you enjoy a smoother and more successful home-buying experience tomorrow.",
      }
    ],
  },
  {
    title: 'Foreclosure Center',
    description:
      'Understand how much home you can comfortably afford. Explore budgeting tips, hidden costs, and monthly payment planning.',
   steps: [
      {
        heading: 'Why Buy Your First Home?',
        intro: 'Owning a home is more than just having a place to live. It offers financial stability, personal freedom, and the opportunity to build long-term wealth.',
        subheading: 'Benefits of Homeownership',
        bullets: [
          'Build equity over time instead of paying rent.',
          'Enjoy greater privacy and security.',
          'Customize your home to match your lifestyle.',
          'Benefit from potential property value appreciation.',
          'Create long-term financial stability for your family',
        ],
        intro2: '',
      },
      {
        heading: 'Step 1: Assess Your Financial Readiness',
        intro: 'Before you begin searching for a home, take a close look at your finances.',
        subheading: 'Consider the following:',
        bullets: [
          'Gather income and employment documents',
          'Compare rates from multiple lenders',
          'Understand fixed vs. adjustable-rate mortgages',
          'Get your pre-approval letter in writing',
        ],
        intro2: 'Having a clear understanding of your financial position will help you determine a comfortable home-buying budget.',
      },
      {
  heading: 'Step 2: Set a Realistic Budget',
  intro:
    'Many first-time buyers focus only on the purchase price, but there are additional costs involved.',
  subheading: 'Include expenses such as:',
  bullets: [
    'Down payment',
    'Loan processing fees',
    'Property registration',
    'Legal documentation',
    'Home inspection',
    'Insurance',
    'Property taxes',
    'Moving expenses',
    'Maintenance costs',
  ],
  intro2:
    'Buying within your budget helps you enjoy homeownership without financial stress.',
},
  {
  heading: 'Step 3: Get Pre-Approved For A Mortgage',
  intro:
    'A mortgage pre-approval gives you an estimate of how much a lender is willing to finance.',
  subheading: 'Advantages include:',
  bullets: [
    'Knowing your price range.',
    'Faster buying process.',
    'Stronger position when making an offer.',
    'Greater confidence while searching.',
  ],
  intro2:
    'Prepare documents such as income proof, bank statements, identity verification, and employment records.',
},
{
  heading: 'Step 4: Choose The Right Location',
  intro:
    "The perfect home isn't just about the property—it's also about the neighborhood.",
  subheading: 'Consider factors like:',
  bullets: [
    'Distance to work',
    'Schools and colleges',
    'Hospitals',
    'Public transportation',
    'Shopping centers',
    'Parks and recreation',
    'Safety and security',
    'Future development plans',
  ],
  intro2:
    "A good location increases both your quality of life and your property's future value.",
},
{
  heading: 'Step 5: Assess Your Financial Readiness',
  intro:
    'Before you begin searching for a home, take a close look at your finances.',
  subheading: 'Consider the following:',
  bullets: [
    'Your monthly income and expenses.',
    'Existing loans or debts.',
    'Savings for a down payment.',
    'Emergency funds.',
    'Credit score and financial history.',
  ],
  intro2:
    'Having a clear understanding of your financial position will help you determine a comfortable home-buying budget.',
},   
{
  heading: 'Step 6: Set A Realistic Budget',
  intro:
    'Many first-time buyers focus only on the purchase price, but there are additional costs involved.',
  subheading: 'Include expenses such as:',
  bullets: [
    'Down payment',
    'Loan processing fees',
    'Property registration',
    'Legal documentation',
    'Home inspection',
    'Insurance',
    'Property taxes',
    'Moving expenses',
    'Maintenance costs',
  ],
  intro2:
    'Buying within your budget helps you enjoy homeownership without financial stress.',
},
{
  heading: 'Step 7: Get Pre-Approved For A Mortgage',
  intro:
    'A mortgage pre-approval gives you an estimate of how much a lender is willing to finance.',
  subheading: 'Advantages include:',
  bullets: [
    'Knowing your price range.',
    'Faster buying process.',
    'Stronger position when making an offer.',
    'Greater confidence while searching.',
  ],
  intro2:
    'Prepare documents such as income proof, bank statements, identity verification, and employment records.',
},{
  heading: 'Step 8: Choose The Right Location',
  intro:
    "The perfect home isn't just about the property—it's also about the neighborhood.",
  subheading: 'Consider factors like:',
  bullets: [
    'Distance to work',
    'Schools and colleges',
    'Hospitals',
    'Public transportation',
    'Shopping centers',
    'Parks and recreation',
    'Safety and security',
    'Future development plans',
  ],
  intro2:
    "A good location increases both your quality of life and your property's future value.",
},{
  heading: 'Common Mistakes To Avoid',
  intro:
    'Many first-time buyers make avoidable errors during the purchasing process.',
  subheading: 'Avoid these common mistakes:',
  bullets: [
    'Buying beyond your budget.',
    'Skipping mortgage pre-approval.',
    'Ignoring additional ownership costs.',
    'Not comparing multiple properties.',
    'Skipping a professional inspection.',
    'Making emotional decisions.',
    'Overlooking neighbourhood research.',
    'Failing to review legal documents thoroughly.',
  ],
  intro2:'',
} ,
{
  heading: 'First-Time Home Buyer Checklist',
  intro:
    "Before purchasing your home, make sure you've completed these essential steps:",
    subheading: '',
  checklist: [
    'Review your finances',
    'Set a realistic budget',
    'Save for a down payment',
    'Get mortgage pre-approval',
    'Research neighbourhoods',
    'Compare multiple properties',
    'Schedule a home inspection',
    'Verify legal documents',
    'Understand closing costs',
    'Secure homeowners insurance',
  ],
   intro2:'',
},
    ],
    finalThoughts: [
      {
         title: "Final Thoughts",
    description:
      "Buying your first home is an exciting journey and one of the most rewarding investments you'll ever make. By planning carefully, understanding each step, and seeking professional guidance when needed, you can make confident decisions and find a home that fits both your lifestyle and your budget.",
      description2:
      "Whether you're just beginning your search or preparing to make an offer, taking the time to educate yourself today will help you enjoy a smoother and more successful home-buying experience tomorrow.",
      }
    ],
  },
  {
    title: 'Down Payment Assistance',
    description:
      'Learn why getting pre-approved strengthens your buying position. Compare financing options and prepare the required documents.',
    steps: [
      {
        heading: 'Why Buy Your First Home?',
        intro: 'Owning a home is more than just having a place to live. It offers financial stability, personal freedom, and the opportunity to build long-term wealth.',
        subheading: 'Benefits of Homeownership',
        bullets: [
          'Build equity over time instead of paying rent.',
          'Enjoy greater privacy and security.',
          'Customize your home to match your lifestyle.',
          'Benefit from potential property value appreciation.',
          'Create long-term financial stability for your family',
        ],
        intro2: '',
      },
      {
        heading: 'Step 1: Assess Your Financial Readiness',
        intro: 'Before you begin searching for a home, take a close look at your finances.',
        subheading: 'Consider the following:',
        bullets: [
          'Gather income and employment documents',
          'Compare rates from multiple lenders',
          'Understand fixed vs. adjustable-rate mortgages',
          'Get your pre-approval letter in writing',
        ],
        intro2: 'Having a clear understanding of your financial position will help you determine a comfortable home-buying budget.',
      },
      {
  heading: 'Step 2: Set a Realistic Budget',
  intro:
    'Many first-time buyers focus only on the purchase price, but there are additional costs involved.',
  subheading: 'Include expenses such as:',
  bullets: [
    'Down payment',
    'Loan processing fees',
    'Property registration',
    'Legal documentation',
    'Home inspection',
    'Insurance',
    'Property taxes',
    'Moving expenses',
    'Maintenance costs',
  ],
  intro2:
    'Buying within your budget helps you enjoy homeownership without financial stress.',
},
  {
  heading: 'Step 3: Get Pre-Approved For A Mortgage',
  intro:
    'A mortgage pre-approval gives you an estimate of how much a lender is willing to finance.',
  subheading: 'Advantages include:',
  bullets: [
    'Knowing your price range.',
    'Faster buying process.',
    'Stronger position when making an offer.',
    'Greater confidence while searching.',
  ],
  intro2:
    'Prepare documents such as income proof, bank statements, identity verification, and employment records.',
},
{
  heading: 'Step 4: Choose The Right Location',
  intro:
    "The perfect home isn't just about the property—it's also about the neighborhood.",
  subheading: 'Consider factors like:',
  bullets: [
    'Distance to work',
    'Schools and colleges',
    'Hospitals',
    'Public transportation',
    'Shopping centers',
    'Parks and recreation',
    'Safety and security',
    'Future development plans',
  ],
  intro2:
    "A good location increases both your quality of life and your property's future value.",
},
{
  heading: 'Step 5: Assess Your Financial Readiness',
  intro:
    'Before you begin searching for a home, take a close look at your finances.',
  subheading: 'Consider the following:',
  bullets: [
    'Your monthly income and expenses.',
    'Existing loans or debts.',
    'Savings for a down payment.',
    'Emergency funds.',
    'Credit score and financial history.',
  ],
  intro2:
    'Having a clear understanding of your financial position will help you determine a comfortable home-buying budget.',
},   
{
  heading: 'Step 6: Set A Realistic Budget',
  intro:
    'Many first-time buyers focus only on the purchase price, but there are additional costs involved.',
  subheading: 'Include expenses such as:',
  bullets: [
    'Down payment',
    'Loan processing fees',
    'Property registration',
    'Legal documentation',
    'Home inspection',
    'Insurance',
    'Property taxes',
    'Moving expenses',
    'Maintenance costs',
  ],
  intro2:
    'Buying within your budget helps you enjoy homeownership without financial stress.',
},
{
  heading: 'Step 7: Get Pre-Approved For A Mortgage',
  intro:
    'A mortgage pre-approval gives you an estimate of how much a lender is willing to finance.',
  subheading: 'Advantages include:',
  bullets: [
    'Knowing your price range.',
    'Faster buying process.',
    'Stronger position when making an offer.',
    'Greater confidence while searching.',
  ],
  intro2:
    'Prepare documents such as income proof, bank statements, identity verification, and employment records.',
},{
  heading: 'Step 8: Choose The Right Location',
  intro:
    "The perfect home isn't just about the property—it's also about the neighborhood.",
  subheading: 'Consider factors like:',
  bullets: [
    'Distance to work',
    'Schools and colleges',
    'Hospitals',
    'Public transportation',
    'Shopping centers',
    'Parks and recreation',
    'Safety and security',
    'Future development plans',
  ],
  intro2:
    "A good location increases both your quality of life and your property's future value.",
},{
  heading: 'Common Mistakes To Avoid',
  intro:
    'Many first-time buyers make avoidable errors during the purchasing process.',
  subheading: 'Avoid these common mistakes:',
  bullets: [
    'Buying beyond your budget.',
    'Skipping mortgage pre-approval.',
    'Ignoring additional ownership costs.',
    'Not comparing multiple properties.',
    'Skipping a professional inspection.',
    'Making emotional decisions.',
    'Overlooking neighbourhood research.',
    'Failing to review legal documents thoroughly.',
  ],
  intro2:'',
} ,
{
  heading: 'First-Time Home Buyer Checklist',
  intro:
    "Before purchasing your home, make sure you've completed these essential steps:",
    subheading: '',
  checklist: [
    'Review your finances',
    'Set a realistic budget',
    'Save for a down payment',
    'Get mortgage pre-approval',
    'Research neighbourhoods',
    'Compare multiple properties',
    'Schedule a home inspection',
    'Verify legal documents',
    'Understand closing costs',
    'Secure homeowners insurance',
  ],
   intro2:'',
},
    ],
    finalThoughts: [
      {
         title: "Final Thoughts",
    description:
      "Buying your first home is an exciting journey and one of the most rewarding investments you'll ever make. By planning carefully, understanding each step, and seeking professional guidance when needed, you can make confident decisions and find a home that fits both your lifestyle and your budget.",
      description2:
      "Whether you're just beginning your search or preparing to make an offer, taking the time to educate yourself today will help you enjoy a smoother and more successful home-buying experience tomorrow.",
      }
    ],
  },
  {
    title: 'Rent With JamboBay',
    description:
      'Find a location that matches your lifestyle and long-term goals. Consider schools, amenities, commute times, and future growth.',
   steps: [
      {
        heading: 'Why Buy Your First Home?',
        intro: 'Owning a home is more than just having a place to live. It offers financial stability, personal freedom, and the opportunity to build long-term wealth.',
        subheading: 'Benefits of Homeownership',
        bullets: [
          'Build equity over time instead of paying rent.',
          'Enjoy greater privacy and security.',
          'Customize your home to match your lifestyle.',
          'Benefit from potential property value appreciation.',
          'Create long-term financial stability for your family',
        ],
        intro2: '',
      },
      {
        heading: 'Step 1: Assess Your Financial Readiness',
        intro: 'Before you begin searching for a home, take a close look at your finances.',
        subheading: 'Consider the following:',
        bullets: [
          'Gather income and employment documents',
          'Compare rates from multiple lenders',
          'Understand fixed vs. adjustable-rate mortgages',
          'Get your pre-approval letter in writing',
        ],
        intro2: 'Having a clear understanding of your financial position will help you determine a comfortable home-buying budget.',
      },
      {
  heading: 'Step 2: Set a Realistic Budget',
  intro:
    'Many first-time buyers focus only on the purchase price, but there are additional costs involved.',
  subheading: 'Include expenses such as:',
  bullets: [
    'Down payment',
    'Loan processing fees',
    'Property registration',
    'Legal documentation',
    'Home inspection',
    'Insurance',
    'Property taxes',
    'Moving expenses',
    'Maintenance costs',
  ],
  intro2:
    'Buying within your budget helps you enjoy homeownership without financial stress.',
},
  {
  heading: 'Step 3: Get Pre-Approved For A Mortgage',
  intro:
    'A mortgage pre-approval gives you an estimate of how much a lender is willing to finance.',
  subheading: 'Advantages include:',
  bullets: [
    'Knowing your price range.',
    'Faster buying process.',
    'Stronger position when making an offer.',
    'Greater confidence while searching.',
  ],
  intro2:
    'Prepare documents such as income proof, bank statements, identity verification, and employment records.',
},
{
  heading: 'Step 4: Choose The Right Location',
  intro:
    "The perfect home isn't just about the property—it's also about the neighborhood.",
  subheading: 'Consider factors like:',
  bullets: [
    'Distance to work',
    'Schools and colleges',
    'Hospitals',
    'Public transportation',
    'Shopping centers',
    'Parks and recreation',
    'Safety and security',
    'Future development plans',
  ],
  intro2:
    "A good location increases both your quality of life and your property's future value.",
},
{
  heading: 'Step 5: Assess Your Financial Readiness',
  intro:
    'Before you begin searching for a home, take a close look at your finances.',
  subheading: 'Consider the following:',
  bullets: [
    'Your monthly income and expenses.',
    'Existing loans or debts.',
    'Savings for a down payment.',
    'Emergency funds.',
    'Credit score and financial history.',
  ],
  intro2:
    'Having a clear understanding of your financial position will help you determine a comfortable home-buying budget.',
},   
{
  heading: 'Step 6: Set A Realistic Budget',
  intro:
    'Many first-time buyers focus only on the purchase price, but there are additional costs involved.',
  subheading: 'Include expenses such as:',
  bullets: [
    'Down payment',
    'Loan processing fees',
    'Property registration',
    'Legal documentation',
    'Home inspection',
    'Insurance',
    'Property taxes',
    'Moving expenses',
    'Maintenance costs',
  ],
  intro2:
    'Buying within your budget helps you enjoy homeownership without financial stress.',
},
{
  heading: 'Step 7: Get Pre-Approved For A Mortgage',
  intro:
    'A mortgage pre-approval gives you an estimate of how much a lender is willing to finance.',
  subheading: 'Advantages include:',
  bullets: [
    'Knowing your price range.',
    'Faster buying process.',
    'Stronger position when making an offer.',
    'Greater confidence while searching.',
  ],
  intro2:
    'Prepare documents such as income proof, bank statements, identity verification, and employment records.',
},{
  heading: 'Step 8: Choose The Right Location',
  intro:
    "The perfect home isn't just about the property—it's also about the neighborhood.",
  subheading: 'Consider factors like:',
  bullets: [
    'Distance to work',
    'Schools and colleges',
    'Hospitals',
    'Public transportation',
    'Shopping centers',
    'Parks and recreation',
    'Safety and security',
    'Future development plans',
  ],
  intro2:
    "A good location increases both your quality of life and your property's future value.",
},{
  heading: 'Common Mistakes To Avoid',
  intro:
    'Many first-time buyers make avoidable errors during the purchasing process.',
  subheading: 'Avoid these common mistakes:',
  bullets: [
    'Buying beyond your budget.',
    'Skipping mortgage pre-approval.',
    'Ignoring additional ownership costs.',
    'Not comparing multiple properties.',
    'Skipping a professional inspection.',
    'Making emotional decisions.',
    'Overlooking neighbourhood research.',
    'Failing to review legal documents thoroughly.',
  ],
  intro2:'',
} ,
{
  heading: 'First-Time Home Buyer Checklist',
  intro:
    "Before purchasing your home, make sure you've completed these essential steps:",
    subheading: '',
  checklist: [
    'Review your finances',
    'Set a realistic budget',
    'Save for a down payment',
    'Get mortgage pre-approval',
    'Research neighbourhoods',
    'Compare multiple properties',
    'Schedule a home inspection',
    'Verify legal documents',
    'Understand closing costs',
    'Secure homeowners insurance',
  ],
   intro2:'',
},
    ],
    finalThoughts: [
      {
         title: "Final Thoughts",
    description:
      "Buying your first home is an exciting journey and one of the most rewarding investments you'll ever make. By planning carefully, understanding each step, and seeking professional guidance when needed, you can make confident decisions and find a home that fits both your lifestyle and your budget.",
      description2:
      "Whether you're just beginning your search or preparing to make an offer, taking the time to educate yourself today will help you enjoy a smoother and more successful home-buying experience tomorrow.",
      }
    ],
  },
  {
    title: 'Renters Insurance',
    description:
      'Stay organized while comparing properties with a practical checklist. Evaluate features, condition, location, and overall value.',
    steps: [
      {
        heading: 'Why Buy Your First Home?',
        intro: 'Owning a home is more than just having a place to live. It offers financial stability, personal freedom, and the opportunity to build long-term wealth.',
        subheading: 'Benefits of Homeownership',
        bullets: [
          'Build equity over time instead of paying rent.',
          'Enjoy greater privacy and security.',
          'Customize your home to match your lifestyle.',
          'Benefit from potential property value appreciation.',
          'Create long-term financial stability for your family',
        ],
        intro2: '',
      },
      {
        heading: 'Step 1: Assess Your Financial Readiness',
        intro: 'Before you begin searching for a home, take a close look at your finances.',
        subheading: 'Consider the following:',
        bullets: [
          'Gather income and employment documents',
          'Compare rates from multiple lenders',
          'Understand fixed vs. adjustable-rate mortgages',
          'Get your pre-approval letter in writing',
        ],
        intro2: 'Having a clear understanding of your financial position will help you determine a comfortable home-buying budget.',
      },
      {
  heading: 'Step 2: Set a Realistic Budget',
  intro:
    'Many first-time buyers focus only on the purchase price, but there are additional costs involved.',
  subheading: 'Include expenses such as:',
  bullets: [
    'Down payment',
    'Loan processing fees',
    'Property registration',
    'Legal documentation',
    'Home inspection',
    'Insurance',
    'Property taxes',
    'Moving expenses',
    'Maintenance costs',
  ],
  intro2:
    'Buying within your budget helps you enjoy homeownership without financial stress.',
},
  {
  heading: 'Step 3: Get Pre-Approved For A Mortgage',
  intro:
    'A mortgage pre-approval gives you an estimate of how much a lender is willing to finance.',
  subheading: 'Advantages include:',
  bullets: [
    'Knowing your price range.',
    'Faster buying process.',
    'Stronger position when making an offer.',
    'Greater confidence while searching.',
  ],
  intro2:
    'Prepare documents such as income proof, bank statements, identity verification, and employment records.',
},
{
  heading: 'Step 4: Choose The Right Location',
  intro:
    "The perfect home isn't just about the property—it's also about the neighborhood.",
  subheading: 'Consider factors like:',
  bullets: [
    'Distance to work',
    'Schools and colleges',
    'Hospitals',
    'Public transportation',
    'Shopping centers',
    'Parks and recreation',
    'Safety and security',
    'Future development plans',
  ],
  intro2:
    "A good location increases both your quality of life and your property's future value.",
},
{
  heading: 'Step 5: Assess Your Financial Readiness',
  intro:
    'Before you begin searching for a home, take a close look at your finances.',
  subheading: 'Consider the following:',
  bullets: [
    'Your monthly income and expenses.',
    'Existing loans or debts.',
    'Savings for a down payment.',
    'Emergency funds.',
    'Credit score and financial history.',
  ],
  intro2:
    'Having a clear understanding of your financial position will help you determine a comfortable home-buying budget.',
},   
{
  heading: 'Step 6: Set A Realistic Budget',
  intro:
    'Many first-time buyers focus only on the purchase price, but there are additional costs involved.',
  subheading: 'Include expenses such as:',
  bullets: [
    'Down payment',
    'Loan processing fees',
    'Property registration',
    'Legal documentation',
    'Home inspection',
    'Insurance',
    'Property taxes',
    'Moving expenses',
    'Maintenance costs',
  ],
  intro2:
    'Buying within your budget helps you enjoy homeownership without financial stress.',
},
{
  heading: 'Step 7: Get Pre-Approved For A Mortgage',
  intro:
    'A mortgage pre-approval gives you an estimate of how much a lender is willing to finance.',
  subheading: 'Advantages include:',
  bullets: [
    'Knowing your price range.',
    'Faster buying process.',
    'Stronger position when making an offer.',
    'Greater confidence while searching.',
  ],
  intro2:
    'Prepare documents such as income proof, bank statements, identity verification, and employment records.',
},{
  heading: 'Step 8: Choose The Right Location',
  intro:
    "The perfect home isn't just about the property—it's also about the neighborhood.",
  subheading: 'Consider factors like:',
  bullets: [
    'Distance to work',
    'Schools and colleges',
    'Hospitals',
    'Public transportation',
    'Shopping centers',
    'Parks and recreation',
    'Safety and security',
    'Future development plans',
  ],
  intro2:
    "A good location increases both your quality of life and your property's future value.",
},{
  heading: 'Common Mistakes To Avoid',
  intro:
    'Many first-time buyers make avoidable errors during the purchasing process.',
  subheading: 'Avoid these common mistakes:',
  bullets: [
    'Buying beyond your budget.',
    'Skipping mortgage pre-approval.',
    'Ignoring additional ownership costs.',
    'Not comparing multiple properties.',
    'Skipping a professional inspection.',
    'Making emotional decisions.',
    'Overlooking neighbourhood research.',
    'Failing to review legal documents thoroughly.',
  ],
  intro2:'',
} ,
{
  heading: 'First-Time Home Buyer Checklist',
  intro:
    "Before purchasing your home, make sure you've completed these essential steps:",
    subheading: '',
  checklist: [
    'Review your finances',
    'Set a realistic budget',
    'Save for a down payment',
    'Get mortgage pre-approval',
    'Research neighbourhoods',
    'Compare multiple properties',
    'Schedule a home inspection',
    'Verify legal documents',
    'Understand closing costs',
    'Secure homeowners insurance',
  ],
   intro2:'',
},
    ],
    finalThoughts: [
      {
         title: "Final Thoughts",
    description:
      "Buying your first home is an exciting journey and one of the most rewarding investments you'll ever make. By planning carefully, understanding each step, and seeking professional guidance when needed, you can make confident decisions and find a home that fits both your lifestyle and your budget.",
      description2:
      "Whether you're just beginning your search or preparing to make an offer, taking the time to educate yourself today will help you enjoy a smoother and more successful home-buying experience tomorrow.",
      }
    ],
  },
  {
    title: 'Rent Guide',
    description:
      'Understand how to submit a competitive offer and negotiate effectively. Learn what factors sellers consider before accepting.',
    steps: [
      {
        heading: 'Why Buy Your First Home?',
        intro: 'Owning a home is more than just having a place to live. It offers financial stability, personal freedom, and the opportunity to build long-term wealth.',
        subheading: 'Benefits of Homeownership',
        bullets: [
          'Build equity over time instead of paying rent.',
          'Enjoy greater privacy and security.',
          'Customize your home to match your lifestyle.',
          'Benefit from potential property value appreciation.',
          'Create long-term financial stability for your family',
        ],
        intro2: '',
      },
      {
        heading: 'Step 1: Assess Your Financial Readiness',
        intro: 'Before you begin searching for a home, take a close look at your finances.',
        subheading: 'Consider the following:',
        bullets: [
          'Gather income and employment documents',
          'Compare rates from multiple lenders',
          'Understand fixed vs. adjustable-rate mortgages',
          'Get your pre-approval letter in writing',
        ],
        intro2: 'Having a clear understanding of your financial position will help you determine a comfortable home-buying budget.',
      },
      {
  heading: 'Step 2: Set a Realistic Budget',
  intro:
    'Many first-time buyers focus only on the purchase price, but there are additional costs involved.',
  subheading: 'Include expenses such as:',
  bullets: [
    'Down payment',
    'Loan processing fees',
    'Property registration',
    'Legal documentation',
    'Home inspection',
    'Insurance',
    'Property taxes',
    'Moving expenses',
    'Maintenance costs',
  ],
  intro2:
    'Buying within your budget helps you enjoy homeownership without financial stress.',
},
  {
  heading: 'Step 3: Get Pre-Approved For A Mortgage',
  intro:
    'A mortgage pre-approval gives you an estimate of how much a lender is willing to finance.',
  subheading: 'Advantages include:',
  bullets: [
    'Knowing your price range.',
    'Faster buying process.',
    'Stronger position when making an offer.',
    'Greater confidence while searching.',
  ],
  intro2:
    'Prepare documents such as income proof, bank statements, identity verification, and employment records.',
},
{
  heading: 'Step 4: Choose The Right Location',
  intro:
    "The perfect home isn't just about the property—it's also about the neighborhood.",
  subheading: 'Consider factors like:',
  bullets: [
    'Distance to work',
    'Schools and colleges',
    'Hospitals',
    'Public transportation',
    'Shopping centers',
    'Parks and recreation',
    'Safety and security',
    'Future development plans',
  ],
  intro2:
    "A good location increases both your quality of life and your property's future value.",
},
{
  heading: 'Step 5: Assess Your Financial Readiness',
  intro:
    'Before you begin searching for a home, take a close look at your finances.',
  subheading: 'Consider the following:',
  bullets: [
    'Your monthly income and expenses.',
    'Existing loans or debts.',
    'Savings for a down payment.',
    'Emergency funds.',
    'Credit score and financial history.',
  ],
  intro2:
    'Having a clear understanding of your financial position will help you determine a comfortable home-buying budget.',
},   
{
  heading: 'Step 6: Set A Realistic Budget',
  intro:
    'Many first-time buyers focus only on the purchase price, but there are additional costs involved.',
  subheading: 'Include expenses such as:',
  bullets: [
    'Down payment',
    'Loan processing fees',
    'Property registration',
    'Legal documentation',
    'Home inspection',
    'Insurance',
    'Property taxes',
    'Moving expenses',
    'Maintenance costs',
  ],
  intro2:
    'Buying within your budget helps you enjoy homeownership without financial stress.',
},
{
  heading: 'Step 7: Get Pre-Approved For A Mortgage',
  intro:
    'A mortgage pre-approval gives you an estimate of how much a lender is willing to finance.',
  subheading: 'Advantages include:',
  bullets: [
    'Knowing your price range.',
    'Faster buying process.',
    'Stronger position when making an offer.',
    'Greater confidence while searching.',
  ],
  intro2:
    'Prepare documents such as income proof, bank statements, identity verification, and employment records.',
},{
  heading: 'Step 8: Choose The Right Location',
  intro:
    "The perfect home isn't just about the property—it's also about the neighborhood.",
  subheading: 'Consider factors like:',
  bullets: [
    'Distance to work',
    'Schools and colleges',
    'Hospitals',
    'Public transportation',
    'Shopping centers',
    'Parks and recreation',
    'Safety and security',
    'Future development plans',
  ],
  intro2:
    "A good location increases both your quality of life and your property's future value.",
},{
  heading: 'Common Mistakes To Avoid',
  intro:
    'Many first-time buyers make avoidable errors during the purchasing process.',
  subheading: 'Avoid these common mistakes:',
  bullets: [
    'Buying beyond your budget.',
    'Skipping mortgage pre-approval.',
    'Ignoring additional ownership costs.',
    'Not comparing multiple properties.',
    'Skipping a professional inspection.',
    'Making emotional decisions.',
    'Overlooking neighbourhood research.',
    'Failing to review legal documents thoroughly.',
  ],
  intro2:'',
} ,
{
  heading: 'First-Time Home Buyer Checklist',
  intro:
    "Before purchasing your home, make sure you've completed these essential steps:",
    subheading: '',
  checklist: [
    'Review your finances',
    'Set a realistic budget',
    'Save for a down payment',
    'Get mortgage pre-approval',
    'Research neighbourhoods',
    'Compare multiple properties',
    'Schedule a home inspection',
    'Verify legal documents',
    'Understand closing costs',
    'Secure homeowners insurance',
  ],
   intro2:'',
},
    ],
    finalThoughts: [
      {
         title: "Final Thoughts",
    description:
      "Buying your first home is an exciting journey and one of the most rewarding investments you'll ever make. By planning carefully, understanding each step, and seeking professional guidance when needed, you can make confident decisions and find a home that fits both your lifestyle and your budget.",
      description2:
      "Whether you're just beginning your search or preparing to make an offer, taking the time to educate yourself today will help you enjoy a smoother and more successful home-buying experience tomorrow.",
      }
    ],
  },
  {
    title: 'Commercial Lease Agreement',
    description:
      'Know what inspectors and appraisers look for before buying. Identify potential issues and make informed purchasing decisions.',
    steps: [
      {
        heading: 'Why Buy Your First Home?',
        intro: 'Owning a home is more than just having a place to live. It offers financial stability, personal freedom, and the opportunity to build long-term wealth.',
        subheading: 'Benefits of Homeownership',
        bullets: [
          'Build equity over time instead of paying rent.',
          'Enjoy greater privacy and security.',
          'Customize your home to match your lifestyle.',
          'Benefit from potential property value appreciation.',
          'Create long-term financial stability for your family',
        ],
        intro2: '',
      },
      {
        heading: 'Step 1: Assess Your Financial Readiness',
        intro: 'Before you begin searching for a home, take a close look at your finances.',
        subheading: 'Consider the following:',
        bullets: [
          'Gather income and employment documents',
          'Compare rates from multiple lenders',
          'Understand fixed vs. adjustable-rate mortgages',
          'Get your pre-approval letter in writing',
        ],
        intro2: 'Having a clear understanding of your financial position will help you determine a comfortable home-buying budget.',
      },
      {
  heading: 'Step 2: Set a Realistic Budget',
  intro:
    'Many first-time buyers focus only on the purchase price, but there are additional costs involved.',
  subheading: 'Include expenses such as:',
  bullets: [
    'Down payment',
    'Loan processing fees',
    'Property registration',
    'Legal documentation',
    'Home inspection',
    'Insurance',
    'Property taxes',
    'Moving expenses',
    'Maintenance costs',
  ],
  intro2:
    'Buying within your budget helps you enjoy homeownership without financial stress.',
},
  {
  heading: 'Step 3: Get Pre-Approved For A Mortgage',
  intro:
    'A mortgage pre-approval gives you an estimate of how much a lender is willing to finance.',
  subheading: 'Advantages include:',
  bullets: [
    'Knowing your price range.',
    'Faster buying process.',
    'Stronger position when making an offer.',
    'Greater confidence while searching.',
  ],
  intro2:
    'Prepare documents such as income proof, bank statements, identity verification, and employment records.',
},
{
  heading: 'Step 4: Choose The Right Location',
  intro:
    "The perfect home isn't just about the property—it's also about the neighborhood.",
  subheading: 'Consider factors like:',
  bullets: [
    'Distance to work',
    'Schools and colleges',
    'Hospitals',
    'Public transportation',
    'Shopping centers',
    'Parks and recreation',
    'Safety and security',
    'Future development plans',
  ],
  intro2:
    "A good location increases both your quality of life and your property's future value.",
},
{
  heading: 'Step 5: Assess Your Financial Readiness',
  intro:
    'Before you begin searching for a home, take a close look at your finances.',
  subheading: 'Consider the following:',
  bullets: [
    'Your monthly income and expenses.',
    'Existing loans or debts.',
    'Savings for a down payment.',
    'Emergency funds.',
    'Credit score and financial history.',
  ],
  intro2:
    'Having a clear understanding of your financial position will help you determine a comfortable home-buying budget.',
},   
{
  heading: 'Step 6: Set A Realistic Budget',
  intro:
    'Many first-time buyers focus only on the purchase price, but there are additional costs involved.',
  subheading: 'Include expenses such as:',
  bullets: [
    'Down payment',
    'Loan processing fees',
    'Property registration',
    'Legal documentation',
    'Home inspection',
    'Insurance',
    'Property taxes',
    'Moving expenses',
    'Maintenance costs',
  ],
  intro2:
    'Buying within your budget helps you enjoy homeownership without financial stress.',
},
{
  heading: 'Step 7: Get Pre-Approved For A Mortgage',
  intro:
    'A mortgage pre-approval gives you an estimate of how much a lender is willing to finance.',
  subheading: 'Advantages include:',
  bullets: [
    'Knowing your price range.',
    'Faster buying process.',
    'Stronger position when making an offer.',
    'Greater confidence while searching.',
  ],
  intro2:
    'Prepare documents such as income proof, bank statements, identity verification, and employment records.',
},{
  heading: 'Step 8: Choose The Right Location',
  intro:
    "The perfect home isn't just about the property—it's also about the neighborhood.",
  subheading: 'Consider factors like:',
  bullets: [
    'Distance to work',
    'Schools and colleges',
    'Hospitals',
    'Public transportation',
    'Shopping centers',
    'Parks and recreation',
    'Safety and security',
    'Future development plans',
  ],
  intro2:
    "A good location increases both your quality of life and your property's future value.",
},{
  heading: 'Common Mistakes To Avoid',
  intro:
    'Many first-time buyers make avoidable errors during the purchasing process.',
  subheading: 'Avoid these common mistakes:',
  bullets: [
    'Buying beyond your budget.',
    'Skipping mortgage pre-approval.',
    'Ignoring additional ownership costs.',
    'Not comparing multiple properties.',
    'Skipping a professional inspection.',
    'Making emotional decisions.',
    'Overlooking neighbourhood research.',
    'Failing to review legal documents thoroughly.',
  ],
  intro2:'',
} ,
{
  heading: 'First-Time Home Buyer Checklist',
  intro:
    "Before purchasing your home, make sure you've completed these essential steps:",
    subheading: '',
  checklist: [
    'Review your finances',
    'Set a realistic budget',
    'Save for a down payment',
    'Get mortgage pre-approval',
    'Research neighbourhoods',
    'Compare multiple properties',
    'Schedule a home inspection',
    'Verify legal documents',
    'Understand closing costs',
    'Secure homeowners insurance',
  ],
   intro2:'',
},
    ],
    finalThoughts: [
      {
         title: "Final Thoughts",
    description:
      "Buying your first home is an exciting journey and one of the most rewarding investments you'll ever make. By planning carefully, understanding each step, and seeking professional guidance when needed, you can make confident decisions and find a home that fits both your lifestyle and your budget.",
      description2:
      "Whether you're just beginning your search or preparing to make an offer, taking the time to educate yourself today will help you enjoy a smoother and more successful home-buying experience tomorrow.",
      }
    ],
  },
  {
    title: 'Commercial Property Management',
    description:
      'Prepare for the final step of your home purchase with confidence. Learn about closing costs, paperwork, and finalizing your ownership.',
    steps: [
      {
        heading: 'Why Buy Your First Home?',
        intro: 'Owning a home is more than just having a place to live. It offers financial stability, personal freedom, and the opportunity to build long-term wealth.',
        subheading: 'Benefits of Homeownership',
        bullets: [
          'Build equity over time instead of paying rent.',
          'Enjoy greater privacy and security.',
          'Customize your home to match your lifestyle.',
          'Benefit from potential property value appreciation.',
          'Create long-term financial stability for your family',
        ],
        intro2: '',
      },
      {
        heading: 'Step 1: Assess Your Financial Readiness',
        intro: 'Before you begin searching for a home, take a close look at your finances.',
        subheading: 'Consider the following:',
        bullets: [
          'Gather income and employment documents',
          'Compare rates from multiple lenders',
          'Understand fixed vs. adjustable-rate mortgages',
          'Get your pre-approval letter in writing',
        ],
        intro2: 'Having a clear understanding of your financial position will help you determine a comfortable home-buying budget.',
      },
      {
  heading: 'Step 2: Set a Realistic Budget',
  intro:
    'Many first-time buyers focus only on the purchase price, but there are additional costs involved.',
  subheading: 'Include expenses such as:',
  bullets: [
    'Down payment',
    'Loan processing fees',
    'Property registration',
    'Legal documentation',
    'Home inspection',
    'Insurance',
    'Property taxes',
    'Moving expenses',
    'Maintenance costs',
  ],
  intro2:
    'Buying within your budget helps you enjoy homeownership without financial stress.',
},
  {
  heading: 'Step 3: Get Pre-Approved For A Mortgage',
  intro:
    'A mortgage pre-approval gives you an estimate of how much a lender is willing to finance.',
  subheading: 'Advantages include:',
  bullets: [
    'Knowing your price range.',
    'Faster buying process.',
    'Stronger position when making an offer.',
    'Greater confidence while searching.',
  ],
  intro2:
    'Prepare documents such as income proof, bank statements, identity verification, and employment records.',
},
{
  heading: 'Step 4: Choose The Right Location',
  intro:
    "The perfect home isn't just about the property—it's also about the neighborhood.",
  subheading: 'Consider factors like:',
  bullets: [
    'Distance to work',
    'Schools and colleges',
    'Hospitals',
    'Public transportation',
    'Shopping centers',
    'Parks and recreation',
    'Safety and security',
    'Future development plans',
  ],
  intro2:
    "A good location increases both your quality of life and your property's future value.",
},
{
  heading: 'Step 5: Assess Your Financial Readiness',
  intro:
    'Before you begin searching for a home, take a close look at your finances.',
  subheading: 'Consider the following:',
  bullets: [
    'Your monthly income and expenses.',
    'Existing loans or debts.',
    'Savings for a down payment.',
    'Emergency funds.',
    'Credit score and financial history.',
  ],
  intro2:
    'Having a clear understanding of your financial position will help you determine a comfortable home-buying budget.',
},   
{
  heading: 'Step 6: Set A Realistic Budget',
  intro:
    'Many first-time buyers focus only on the purchase price, but there are additional costs involved.',
  subheading: 'Include expenses such as:',
  bullets: [
    'Down payment',
    'Loan processing fees',
    'Property registration',
    'Legal documentation',
    'Home inspection',
    'Insurance',
    'Property taxes',
    'Moving expenses',
    'Maintenance costs',
  ],
  intro2:
    'Buying within your budget helps you enjoy homeownership without financial stress.',
},
{
  heading: 'Step 7: Get Pre-Approved For A Mortgage',
  intro:
    'A mortgage pre-approval gives you an estimate of how much a lender is willing to finance.',
  subheading: 'Advantages include:',
  bullets: [
    'Knowing your price range.',
    'Faster buying process.',
    'Stronger position when making an offer.',
    'Greater confidence while searching.',
  ],
  intro2:
    'Prepare documents such as income proof, bank statements, identity verification, and employment records.',
},{
  heading: 'Step 8: Choose The Right Location',
  intro:
    "The perfect home isn't just about the property—it's also about the neighborhood.",
  subheading: 'Consider factors like:',
  bullets: [
    'Distance to work',
    'Schools and colleges',
    'Hospitals',
    'Public transportation',
    'Shopping centers',
    'Parks and recreation',
    'Safety and security',
    'Future development plans',
  ],
  intro2:
    "A good location increases both your quality of life and your property's future value.",
},{
  heading: 'Common Mistakes To Avoid',
  intro:
    'Many first-time buyers make avoidable errors during the purchasing process.',
  subheading: 'Avoid these common mistakes:',
  bullets: [
    'Buying beyond your budget.',
    'Skipping mortgage pre-approval.',
    'Ignoring additional ownership costs.',
    'Not comparing multiple properties.',
    'Skipping a professional inspection.',
    'Making emotional decisions.',
    'Overlooking neighbourhood research.',
    'Failing to review legal documents thoroughly.',
  ],
  intro2:'',
} ,
{
  heading: 'First-Time Home Buyer Checklist',
  intro:
    "Before purchasing your home, make sure you've completed these essential steps:",
    subheading: '',
  checklist: [
    'Review your finances',
    'Set a realistic budget',
    'Save for a down payment',
    'Get mortgage pre-approval',
    'Research neighbourhoods',
    'Compare multiple properties',
    'Schedule a home inspection',
    'Verify legal documents',
    'Understand closing costs',
    'Secure homeowners insurance',
  ],
   intro2:'',
},
    ],
    finalThoughts: [
      {
         title: "Final Thoughts",
    description:
      "Buying your first home is an exciting journey and one of the most rewarding investments you'll ever make. By planning carefully, understanding each step, and seeking professional guidance when needed, you can make confident decisions and find a home that fits both your lifestyle and your budget.",
      description2:
      "Whether you're just beginning your search or preparing to make an offer, taking the time to educate yourself today will help you enjoy a smoother and more successful home-buying experience tomorrow.",
      }
    ],
  },
    {
    title: 'Lease Guide',
    description:
      'Prepare for the final step of your home purchase with confidence. Learn about closing costs, paperwork, and finalizing your ownership.',
    steps: [
      {
        heading: 'Why Buy Your First Home?',
        intro: 'Owning a home is more than just having a place to live. It offers financial stability, personal freedom, and the opportunity to build long-term wealth.',
        subheading: 'Benefits of Homeownership',
        bullets: [
          'Build equity over time instead of paying rent.',
          'Enjoy greater privacy and security.',
          'Customize your home to match your lifestyle.',
          'Benefit from potential property value appreciation.',
          'Create long-term financial stability for your family',
        ],
        intro2: '',
      },
      {
        heading: 'Step 1: Assess Your Financial Readiness',
        intro: 'Before you begin searching for a home, take a close look at your finances.',
        subheading: 'Consider the following:',
        bullets: [
          'Gather income and employment documents',
          'Compare rates from multiple lenders',
          'Understand fixed vs. adjustable-rate mortgages',
          'Get your pre-approval letter in writing',
        ],
        intro2: 'Having a clear understanding of your financial position will help you determine a comfortable home-buying budget.',
      },
      {
  heading: 'Step 2: Set a Realistic Budget',
  intro:
    'Many first-time buyers focus only on the purchase price, but there are additional costs involved.',
  subheading: 'Include expenses such as:',
  bullets: [
    'Down payment',
    'Loan processing fees',
    'Property registration',
    'Legal documentation',
    'Home inspection',
    'Insurance',
    'Property taxes',
    'Moving expenses',
    'Maintenance costs',
  ],
  intro2:
    'Buying within your budget helps you enjoy homeownership without financial stress.',
},
  {
  heading: 'Step 3: Get Pre-Approved For A Mortgage',
  intro:
    'A mortgage pre-approval gives you an estimate of how much a lender is willing to finance.',
  subheading: 'Advantages include:',
  bullets: [
    'Knowing your price range.',
    'Faster buying process.',
    'Stronger position when making an offer.',
    'Greater confidence while searching.',
  ],
  intro2:
    'Prepare documents such as income proof, bank statements, identity verification, and employment records.',
},
{
  heading: 'Step 4: Choose The Right Location',
  intro:
    "The perfect home isn't just about the property—it's also about the neighborhood.",
  subheading: 'Consider factors like:',
  bullets: [
    'Distance to work',
    'Schools and colleges',
    'Hospitals',
    'Public transportation',
    'Shopping centers',
    'Parks and recreation',
    'Safety and security',
    'Future development plans',
  ],
  intro2:
    "A good location increases both your quality of life and your property's future value.",
},
{
  heading: 'Step 5: Assess Your Financial Readiness',
  intro:
    'Before you begin searching for a home, take a close look at your finances.',
  subheading: 'Consider the following:',
  bullets: [
    'Your monthly income and expenses.',
    'Existing loans or debts.',
    'Savings for a down payment.',
    'Emergency funds.',
    'Credit score and financial history.',
  ],
  intro2:
    'Having a clear understanding of your financial position will help you determine a comfortable home-buying budget.',
},   
{
  heading: 'Step 6: Set A Realistic Budget',
  intro:
    'Many first-time buyers focus only on the purchase price, but there are additional costs involved.',
  subheading: 'Include expenses such as:',
  bullets: [
    'Down payment',
    'Loan processing fees',
    'Property registration',
    'Legal documentation',
    'Home inspection',
    'Insurance',
    'Property taxes',
    'Moving expenses',
    'Maintenance costs',
  ],
  intro2:
    'Buying within your budget helps you enjoy homeownership without financial stress.',
},
{
  heading: 'Step 7: Get Pre-Approved For A Mortgage',
  intro:
    'A mortgage pre-approval gives you an estimate of how much a lender is willing to finance.',
  subheading: 'Advantages include:',
  bullets: [
    'Knowing your price range.',
    'Faster buying process.',
    'Stronger position when making an offer.',
    'Greater confidence while searching.',
  ],
  intro2:
    'Prepare documents such as income proof, bank statements, identity verification, and employment records.',
},{
  heading: 'Step 8: Choose The Right Location',
  intro:
    "The perfect home isn't just about the property—it's also about the neighborhood.",
  subheading: 'Consider factors like:',
  bullets: [
    'Distance to work',
    'Schools and colleges',
    'Hospitals',
    'Public transportation',
    'Shopping centers',
    'Parks and recreation',
    'Safety and security',
    'Future development plans',
  ],
  intro2:
    "A good location increases both your quality of life and your property's future value.",
},{
  heading: 'Common Mistakes To Avoid',
  intro:
    'Many first-time buyers make avoidable errors during the purchasing process.',
  subheading: 'Avoid these common mistakes:',
  bullets: [
    'Buying beyond your budget.',
    'Skipping mortgage pre-approval.',
    'Ignoring additional ownership costs.',
    'Not comparing multiple properties.',
    'Skipping a professional inspection.',
    'Making emotional decisions.',
    'Overlooking neighbourhood research.',
    'Failing to review legal documents thoroughly.',
  ],
  intro2:'',
} ,
{
  heading: 'First-Time Home Buyer Checklist',
  intro:
    "Before purchasing your home, make sure you've completed these essential steps:",
    subheading: '',
  checklist: [
    'Review your finances',
    'Set a realistic budget',
    'Save for a down payment',
    'Get mortgage pre-approval',
    'Research neighbourhoods',
    'Compare multiple properties',
    'Schedule a home inspection',
    'Verify legal documents',
    'Understand closing costs',
    'Secure homeowners insurance',
  ],
   intro2:'',
},
    ],
    finalThoughts: [
      {
         title: "Final Thoughts",
    description:
      "Buying your first home is an exciting journey and one of the most rewarding investments you'll ever make. By planning carefully, understanding each step, and seeking professional guidance when needed, you can make confident decisions and find a home that fits both your lifestyle and your budget.",
      description2:
      "Whether you're just beginning your search or preparing to make an offer, taking the time to educate yourself today will help you enjoy a smoother and more successful home-buying experience tomorrow.",
      }
    ],
  },
];

export const resources = rawResources.map((resource) => ({
  ...resource,
  slug: slugify(resource.title),
}));

export const getResourceBySlug = (slug) =>
  resources.find((resource) => resource.slug === slug);
